module.exports = __webpack_public_path__ + "static/media/IMG_E9188a.4e9c7744.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/IMG_E9188a.jpg
// module id = 149
// module chunks = 0